import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=50ba4c44&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=50ba4c44&prod&lang=scss"
import style1 from "./dynamic.vue?vue&type=style&index=1&id=50ba4c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba4c44",
  null
  
)

export default component.exports